import React, { Component } from "react";
import { Navigate } from "react-router-dom";
import { withRouter } from '../../common/with-router';
import {Card, Form, Button, Row, Col, Table, Dropdown} from "react-bootstrap";
import AsyncSelect from 'react-select/async';
import { FaPlus, FaRegEdit, FaSearch, FaFilter, FaFileExport, FaEraser, FaTrash } from "react-icons/fa";
import api from "../../services/api";
import { hasPerm, getCurrentUser } from '../../common/utils';
import Paginacao from '../../common/pagination';
import Swal from 'sweetalert2';

class GotoConnectAtendimentos extends Component {
    constructor(props) {
        super(props);
        this.onClickPagina = this.onClickPagina.bind(this);
        this.buscaGotoConnect = this.buscaGotoConnect.bind(this);

        this.state = {
            listRegistros: [],
            error: "",
            filtro_programa_id: '',
            telefone: '',
            page_numb: 1,
            loading: true,
            atendimento_id: null
        };
    }

    componentDidMount() {
        const { atendimento_id, programa_id, beneficiario_dados } = this.props;

        let telefone = '';
        if (beneficiario_dados) {
            telefone = beneficiario_dados.telefone || beneficiario_dados.celular || '';
            telefone = telefone.replace(/\D/g, ''); 
        }

        this.setState({
            atendimento_id,
            filtro_programa_id: programa_id,
            telefone
        }, () => {
            this.consultaGotoConnect(1);
        });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.atendimento_id !== this.props.atendimento_id ||
            prevProps.programa_id !== this.props.programa_id ||
            prevProps.beneficiario_dados !== this.props.beneficiario_dados) {

            const telefone = this.props.beneficiario_dados?.telefone || this.props.beneficiario_dados?.celular || '';

            this.setState({
                atendimento_id: this.props.atendimento_id,
                filtro_programa_id: this.props.programa_id,
                telefone
            }, () => {
                this.consultaGotoConnect(1);
            });
        }
    }

    consultaGotoConnect(page_numb = 1) {
        const { telefone } = this.state;

        if (!telefone || telefone.trim() === '') {
            this.setState({
                loading: false,
                listRegistros: [],
                error: 'Paciente sem número para consultar Histórico da GoTo Connect'
            });
            return;
        }

        let url = `/gotoconnect/historico_ligacoes/?page=${page_numb}&atendimento_id=${this.state.atendimento_id}`;

        if (this.state.filtro_programa_id) {
            url += `&programa_id=${this.state.filtro_programa_id}`;
        }

        if (this.state.telefone) {
            url += `&num_telefone=${this.state.telefone}`;
        }

        this.setState({ loading: true });

        api.get(url)
            .then(response => {
                this.setState({
                    loading: false,
                    error: "",
                    listRegistros: response.data,
                    page_numb
                });
            })
            .catch(error => {
                let erro_msg = 'Erro ao consultar GotoConnect, tente novamente.';

                if (error.response?.status === 500) {
                    erro_msg = 'Servidor indisponível no momento';
                } else if (error.response?.status === 403) {
                    erro_msg = 'Você não tem permissão para acessar essa área';
                }

                this.setState({
                    loading: false,
                    error: erro_msg
                });
            });
    }

    renderRows = () => {
        if('results' in this.state.listRegistros && this.state.listRegistros.results.length > 0){
            return this.state.listRegistros.results.map((item) =>
            <tr key={item.id}>
                <td>{item.legId}</td>
                <td>{item.data_inicio}</td>
                <td>{item.data_resposta}</td>
                <td>{item.direcao}</td>
                <td>{item.duracao}</td>
                {/*<td>{item.chave_usuario}</td>*/}
                <td>{item.caller_numero} 
                    {item.caller_nome ? ` (${item.caller_nome})` : ''}
                </td>
                <td>
                    {item.callee_numero} 
                    {item.callee_nome ? ` (${item.callee_nome})` : ''}
                </td>
                <td>
                    {item.link_arquivo_audio && (
                        <a href={item.link_arquivo_audio} rel="noopener noreferrer" target="_blank">Áudio</a>
                    )}                    
                </td>
            </tr>
            );
        }        

        return (
            <tr>
                <td colSpan={3}>Nenhum gotoconnect encontrado</td>
            </tr>
        );
    };

    onClickPagina(num_page) {
        this.setState({
            loading: true,
            page_numb: num_page
        });
        
        this.consultaGotoConnect(num_page)
    };
    
    buscaGotoConnect(e) {
        e.preventDefault();

        this.setState({
            loading: true,
        });
        
        this.consultaGotoConnect(this.state.busca)
    };

    render() {
        if (!hasPerm('view_goto_connect')) {
            return <Navigate to='/sem-permissao' />
        }

        let dados_usuario = getCurrentUser();

        return (
            <div>
                <Card className="cardDestaque">
                    <Card.Body>                    
                        <Col sm={6} lg={6}>
                            <h6><strong>GotoConnect</strong></h6>
                        </Col>
                        <Table responsive className="custom-table">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Data Início</th>
                                    <th>Data Resposta</th>
                                    <th>Direção</th>
                                    <th>Duração</th>
                                    {/*<th>Chave Usuário</th>*/}
                                    <th>Quem Ligou</th>
                                    <th>Quem Atendeu</th>
                                    <th>Áudio</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.loading ? (
                                <tr>
                                    <td colSpan={8}>Carregando...</td>
                                </tr>
                                ) : (
                                    this.state.error ? (
                                        <tr>
                                            <td colSpan={8}>{this.state.error}</td>
                                        </tr>
                                    ) : this.renderRows()
                                )}                                                       
                            </tbody>
                        </Table>       
                        { 
                            'results' in this.state.listRegistros && this.state.listRegistros.results.length > 0 && 
                            <Paginacao dados={this.state.listRegistros} loading={this.state.loading} page_numb={this.state.page_numb} _onClickPagina={this.onClickPagina} />
                        }                    
                    </Card.Body>                
                </Card>
            </div>
        );
    }
}

export default withRouter(GotoConnectAtendimentos);